module.exports = __webpack_public_path__ + "img/IMG_3509.b1c89dc2.jpeg";